import script from "./AdminKanbanPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminKanbanPanel.vue?vue&type=script&setup=true&lang=js"

import "./AdminKanbanPanel.vue?vue&type=style&index=0&id=5caed935&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5caed935"]])

export default __exports__